import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Icon from './Icon';
import { palette, breakpoints } from '../../constants/styles';
import Text from './Text';
import { phoneNumber, fancyPhoneNumber } from '../../constants/constants';
import Modal from './Modal';

const StyledCallUs = styled.div`
  cursor: pointer;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  border: 1px solid ${palette.secondaryColor};
  ${({ following }) =>
    following &&
    css`
      position: fixed;
      bottom: 75px;
      right: 35px;
      ${breakpoints.mobileLandscape} {
        right: 20%;
      }
      ${breakpoints.tablet} {
        right: 25%;
      }
      ${breakpoints.tabletLandscape} {
        right: 30%;
      }
      ${breakpoints.desktop} {
        right: 35%;
      }
    `};

  ${({ hide }) =>
    hide == '0' &&
    css`
      display: none;
    `};
`;

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some(toMatchItem => {
    return navigator.userAgent.match(toMatchItem);
  });
}

const StyledModal = styled.div`
  margin: 20px;
`;

class CallUs extends Component {
  state = {
    showModal: false,
    modalIsOpen: false,
  };

  closeModal = () => {
    console.log('here');
    this.setState({ showModal: false });
  };

  render() {
    const { showModal, modalIsOpen } = this.state;
    const { following, hide } = this.props;
    return (
      <StyledCallUs
        following={following}
        hide={hide}
        onClick={() => {
          if (detectMob()) {
            console.log('mobile');
            window.open('tel:' + phoneNumber);
          } else if (!modalIsOpen) {
            console.log('browser');
            this.setState({ showModal: true, modalIsOpen: true });
          } else {
            this.setState({ modalIsOpen: false });
          }
        }}
      >
        <Modal
          show={showModal}
          onCloseModal={() => {
            this.closeModal();
          }}
        >
          {() => (
            <StyledModal>
              <Text type="body2">
                Llámanos al <b>+52 {fancyPhoneNumber}</b>
              </Text>
              <Text type="body2">Estamos disponibles de 9 a 18 hrs de lunes a sábado</Text>
            </StyledModal>
          )}
        </Modal>
        <Icon
          icon="phoneStepGreen"
          color={palette.secondaryColor}
          size={35}
          style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer', transform: 'scaleX(-1)' }}
        />
        <Text type="body" align="center" color={palette.darkerGray} styles={{ marginTop: '5px' }}>
          ¿Dudas? Llámanos
        </Text>
      </StyledCallUs>
    );
  }
}
export default CallUs;
